import { SvgIconComponent } from '@mui/icons-material';
import { Box, FormControl, InputLabel, MenuItem, Select, SxProps, Theme } from '@mui/material';
import { FC } from 'react';
import { v4 } from 'uuid';
import { AppIcons } from '../../settings/icons';

interface IProps 
{
  title: string;
  objects: IObjectSelectorItem[];
  selectedObject: number;
  disabled?: boolean;
  onSelection: (index: number)=>void;
  sx?: SxProps<Theme>;
}

export interface IObjectSelectorItem
{
    title: string;
    icon?: SvgIconComponent;
}

const ObjectSelector: FC<IProps> = ({ title, objects, selectedObject, disabled, onSelection, sx }) => 
{
    const inputLabelId = `object-selector-label-${v4()}`;
    const inputSelectId = `object-selector-select-${v4()}`;

    return (<>
        <Box sx={sx}>
            <FormControl fullWidth>

                {/** TITLE **/}
                <InputLabel id={inputLabelId}>
                    {title}
                </InputLabel>

                {/** SELECTION BOX **/}
                <Select
                    labelId={inputLabelId}
                    id={inputSelectId}
                    disabled={disabled}
                    value={selectedObject}
                    label={title}
                    onChange={(event)=>{
                        const value = event.target.value;
                        onSelection(typeof(value) === "string" ? 
                            parseInt(value) : 
                            value
                        );
                    }}
                >
                    {
                        objects.map((obj, index) => {
                            const Icon = obj.icon ?? AppIcons.Default;
                            return (<MenuItem key={`object-selector-menu-item-${obj.title}`} value={index}>
                                <Icon sx={{verticalAlign: "bottom", marginRight: 5}}/>
                                {obj.title}
                            </MenuItem>)
                        })
                    }
                </Select>
                
            </FormControl>
        </Box>
    </>);
};

export default ObjectSelector;